import { useMutation } from '@apollo/client/react';

import {
  CardPaymentAuthorised,
  PaymentDetails,
  PaymentSubmissionOutcome,
  SubmitDepositMutationMutation,
} from '@generated/gql/graphql';
import { formatCurrency } from '@utils/format';

import { submitDepositDetails } from './query';
import { useTrackedOrderSubmit } from './useTrackedOrderSubmit';

const isCardPaymentAuthorised = (
  submitDeposit: PaymentSubmissionOutcome
): submitDeposit is CardPaymentAuthorised =>
  submitDeposit?.__typename === 'CardPaymentAuthorised';

const useSubmitDepositOrder = (value: string, currency: string) => {
  const { submitAndCompleteOrder, submitOrderError, submitOrderLoading } =
    useTrackedOrderSubmit(value);

  const [
    submitDeposit,
    {
      data: submitDepositData,
      error: submitDepositError,
      loading: submitDepositLoading,
    },
  ] = useMutation(submitDepositDetails);

  const handleSubmitDeposit = async (
    basketId: string,
    paymentDetails: PaymentDetails
  ) =>
    submitDeposit({
      variables: { basketId, paymentDetails },
      onCompleted: (data: SubmitDepositMutationMutation) => {
        if (isCardPaymentAuthorised(data.submitDeposit)) {
          submitAndCompleteOrder({
            depositAmount: formatCurrency({ value, currency }),
          });
        }
      },
    });

  return {
    isLoading: submitDepositLoading || submitOrderLoading,
    error: submitDepositError || submitOrderError,
    submitDepositData,
    handleSubmitDeposit,
  };
};

export { useSubmitDepositOrder };
